require([
    'jquery',
    'semantic',
    'ch_search',
    'ch_ga',
], function ($, __, chSearch, ga) {
    function initializeHubSelector() {
        var $hubSelectBox = $('.hub-select');
        var $searchKeyword = $('.js-search-by-keyword');

        $hubSelectBox.dropdown();

        $hubSelectBox.on('change', function () {
            var hub = $hubSelectBox.dropdown('get value').toLowerCase();

            Filters.hub = hub;
            Filters.kw = encodeURIComponent($searchKeyword.search('get value'));

            ga('send', 'event', 'Hub Selection', 'Hub Select Box Changed', 'Hub changed - ' + Filters.hub);

            if (!Filters.kw) {
                Filters.suggest = null;

                // If you're not on a hub-specific page (eg: /contact-us), go to the hub page
                if (window.location.pathname.indexOf('/' + CH.Hub.uri + '/') === -1) {
                    window.location.href = '/' + hub;
                    return;
                } else if (CH.is_course_page) {
                    window.location.href = '/' + Filters.hub + '/classes';
                    return;
                }
            }

            chSearch.submit();
        });

        $hubSelectBox.on('click', function () {
            ga('send', 'event', 'Hub Selection', 'Hub Select Box Clicked', 'Hub selection box clicked');
        });
    }

    if (!CH.isMobile && CH.isSearchSelectbox) {
        $(function () {
            initializeHubSelector();
        });
    }
});

define("ch_semantic_search", function(){});

